import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
  HttpParams,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, filter, of } from 'rxjs';
import { ApiRequestProps } from './api.types';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  constructor(private readonly httpClient: HttpClient) {}

  request<TRes, TParams = undefined, TBody = undefined>(
    props: ApiRequestProps<TParams, TBody>
  ): Observable<HttpResponse<TRes>> {
    const config = {
      params: props?.params as HttpParams,
      headers: this.getHeaders(props?.customHeaders),
      context: props?.context,
      responseType: props?.responseType || 'json',
    };
    return this.httpClient
      .request<TRes>(
        new HttpRequest<TBody>(
          props.method,
          props.url,
          props?.body || null,
          config!
        )
      )
      .pipe(filter((req) => req instanceof HttpResponse)) as Observable<
      HttpResponse<TRes>
    >;
  }

  private getHeaders(customHeaders?: Record<string, any>): HttpHeaders {
    let headers = new HttpHeaders();
    headers = headers.set('Accept', 'application/json');
    if (!customHeaders) {
      return headers;
    }
    for (const [key, value] of Object.entries(customHeaders)) {
      headers = headers.set(key, value);
    }
    return headers;
  }
}
